"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgHelpCircleFilled(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("path", { d: "M16 2a14 14 0 1014 14A14 14 0 0016 2zm-1.51 20.49A1.49 1.49 0 0116 21a1.68 1.68 0 01.6.11 1.46 1.46 0 01.91 1.37A1.48 1.48 0 0116 24a1.39 1.39 0 01-.3 0 1.49 1.49 0 01-1.21-1.51zM18 16.13A1.76 1.76 0 0017 18v1h-2v-1a3.69 3.69 0 011.87-3.55c.68-.45 1.13-.74 1.13-2.3S17.48 10 16 10c-1.31 0-1.66.5-1.83 1a3.53 3.53 0 00-.17 1.15h-2a5.45 5.45 0 01.27-1.8C12.63 9.28 13.58 8 16 8c2.58 0 4 1.48 4 4.15s-1.16 3.41-2 3.98z" })));
}
exports.default = SvgHelpCircleFilled;
//# sourceMappingURL=HelpCircleFilled.js.map